import { render, staticRenderFns } from "./MSwitches.vue?vue&type=template&id=723baab4&scoped=true"
import script from "./MSwitches.vue?vue&type=script&lang=js"
export * from "./MSwitches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723baab4",
  null
  
)

export default component.exports